// provider.js — the one stored fact about where this panel signs in.
//
// The cluster's sign-in provider, as the issuer a member named, and the address that named it when
// that was not the page's own origin. Not a credential: a stale one costs a sign-in that fails and is
// asked again, never a wrong session, because a token is only ever accepted on its signature.
//
// Imports nothing, so the modules beneath the session layer can read it without importing it.

const PROVIDER_KEY = "krystal:provider";   // localStorage: {issuer, via}

function readProvider() {
  try {
    const raw = localStorage.getItem(PROVIDER_KEY);
    const p = raw ? JSON.parse(raw) : null;
    return p && typeof p.issuer === "string" && p.issuer ? { issuer: p.issuer, via: p.via || null } : null;
  } catch { return null; }
}

function writeProvider(p) {
  try {
    if (p && p.issuer) localStorage.setItem(PROVIDER_KEY, JSON.stringify({ issuer: p.issuer, via: p.via || null }));
    else localStorage.removeItem(PROVIDER_KEY);
  } catch { /* private mode */ }
}

export { PROVIDER_KEY, readProvider, writeProvider };
